import { isFinite } from 'lodash';
import {
  IChildWorksheetSpaceType,
  IWorksheetRow,
} from 'spw-redux/modules/calculators/types';
import {
  IDepartment,
  IProjectSpaceTypeCategory,
  IProjectSpaceTypeSubcategory,
} from 'spw-redux/modules/projects/types';
import {
  IProjectSpaceType,
  ISpaceType,
} from 'spw-redux/modules/space_types/types';
import WorksheetStorageSpaceRow from './WorksheetStorageSpaceRow';

export default class WorksheetRow {
  id?: number;

  quantity: number;

  seatCap: number;

  sizeX: number;

  sizeY: number;

  usf: number;

  ratio: number;

  spaceType: ISpaceType | IChildWorksheetSpaceType;

  category: string;

  subcategory: string;

  projectSpaceType: Partial<IProjectSpaceType>;

  projectSpaceTypeCategory: IProjectSpaceTypeCategory;

  projectSpaceTypeSubcategory: IProjectSpaceTypeSubcategory;

  isIncludedInTotalWorkSeats: boolean;

  removed: boolean;

  name?: string;

  child?: boolean;

  spaceId?: number;

  totalUsf?: number;

  spaceTypeId?: number;

  isStorageSupportSpace = false;

  uniqueKey: string;

  presorted?: boolean;

  worksheetId?: number;

  department?: IDepartment;

  title?: string;

  subtitle?: string;

  constructor(row: IWorksheetRow, worksheetId?: number) {
    this.quantity = row.quantity;
    this.seatCap = row.seatCap;
    this.name = row.spaceType.name;
    this.child = row.child;
    this.spaceTypeId = row.spaceTypeId;
    this.spaceType = row.spaceType;
    this.spaceId = row.projectSpaceType?.id;
    this.usf = row.usf;
    this.totalUsf = row.quantity * row.usf;
    this.id = row.id;
    this.removed = row.removed;
    this.category = row.category.defaultSpaceTypeCategory.category;
    this.subcategory = row.subcategory?.defaultSpaceTypeCategory.category;
    this.projectSpaceType = row.projectSpaceType;
    this.projectSpaceTypeCategory = row.category;
    this.projectSpaceTypeSubcategory = row.subcategory;
    this.isIncludedInTotalWorkSeats = row.subcategory
      ? row.subcategory.includeInTotalWorkSeats
      : true;
    this.ratio = isFinite(row.ratio) ? row.ratio : 0;
    this.uniqueKey = `${this.spaceType.name}_${this.spaceTypeId}`;
    this.sizeX = row.sizeX;
    this.sizeY = row.sizeY;
    this.worksheetId = worksheetId;
    this.department = row.department;
  }

  static removeRowValues(row: WorksheetRow): WorksheetRow {
    return {
      ...row,
      totalUsf: 0,
      quantity: 0,
      usf: 0,
      sizeX: 0,
      sizeY: 0,
      seatCap: 0,
      ratio: 0,
    };
  }

  static toAPIWorksheetRow = (
    row: WorksheetRow | WorksheetStorageSpaceRow
  ): IWorksheetRow => ({
    id: row.id,
    quantity: row.quantity,
    seatCap: row.seatCap,
    sizeX: row.sizeX,
    sizeY: row.sizeY,
    usf: row.usf,
    ratio: row.ratio,
    child: row.child,
    spaceId: row.spaceTypeId,
    projectSpaceType: row.projectSpaceType,
    spaceType: row.spaceType,
    spaceTypeId: row.spaceTypeId,
    category: row.projectSpaceTypeCategory,
    subcategory: row.projectSpaceTypeSubcategory,
    removed: row.removed,
  });
}
